module.exports = __webpack_public_path__ + "img/ef_detail_more_b_fx.189950e1.png";